import Cookies from 'js-cookie';

export const COOKIE_CONSENT_KEY = 'cookie-consent';
export const FORM_DATA_KEY = 'halalcred-form-data';

export const hasCookieConsent = () => {
  return Cookies.get(COOKIE_CONSENT_KEY) === 'accepted';
};

export const saveFormData = (data) => {
  if (hasCookieConsent()) {
    // Store in cookies with 7 days expiry
    Cookies.set(FORM_DATA_KEY, JSON.stringify(data), { expires: 7 });
  } else {
    // Fallback to sessionStorage if no cookie consent
    sessionStorage.setItem(FORM_DATA_KEY, JSON.stringify(data));
  }
};

export const getFormData = () => {
  if (hasCookieConsent()) {
    const cookieData = Cookies.get(FORM_DATA_KEY);
    return cookieData ? JSON.parse(cookieData) : null;
  }
  const sessionData = sessionStorage.getItem(FORM_DATA_KEY);
  return sessionData ? JSON.parse(sessionData) : null;
};

export const clearFormData = () => {
  if (hasCookieConsent()) {
    Cookies.remove(FORM_DATA_KEY);
  }
  sessionStorage.removeItem(FORM_DATA_KEY);
}; 